// @flow

import React, { Component } from "react";
import { Button } from "react-bootstrap";
import ReactGA from "react-ga";

import "./Wikipedia.css";

type State = {
  open: boolean
};

type Props = {};

class Wikipedia extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      open: false
    };
  }

  show = () => {
    this.setState({ open: true });
    ReactGA.event({ category: "Task", action: "Show Wikipedia" });
  };

  render() {
    if (this.state.open) {
      return (
        <div className="Wikipedia">
          <iframe
            title="Wikipedia"
            className="Wikipedia-Frame"
            src="//en.m.wikipedia.org/w/index.php?search="
          />
        </div>
      );
    } else {
      return (
        <div className="Wikipedia">
          <Button onClick={this.show}>Show Wikipedia</Button>
        </div>
      );
    }
  }
}

export default Wikipedia;



// WEBPACK FOOTER //
// ./src/components/Wikipedia/Wikipedia.js